var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(("padding: 20px 0px; margin: 0px " + _vm.horizontalMargin + "px"))},[_c('v-divider')],1)}
var staticRenderFns = []

export { render, staticRenderFns }